import { ApiRequest, BaseResource, postItem } from "utils/ApiUtils";
import buildQuery from 'odata-query';
import ODataUtil from "./ODataUtil";
import { Schema, Field } from "utils/SchemaUtils";
import { FieldFormsResult, FieldFormResultDetails } from 'classes';

const fieldFormsResultEndpoint = "/TestFieldFormsResults";

function convertFieldFormsToTableSchema({ "value": items, "@odata.count": count }) {
  let { data } = FieldFormsResult.convertToTableRows({ "value": items, "@odata.count": count });
  data = data.map((r, index) => {
    // r.MaterialDesc_FieldMaterial = `${r.MaterialCode_FieldMaterial} | ${r.MaterialDesc_FieldMaterial} | ${r.SpecItem_FieldMaterial}`
    r.XrefFieldTest = items[index].XrefFieldTest;
    r.Description_ReviewStatus = items[index].SampleTestReviews.length > 0 ? items[index].SampleTestReviews[0].ReviewStatus.Description : null;
    return r;
  });
  return {
    data, count
  };
};

async function getFieldFormsResults(page, per_page, orderByInfo, orderByDirection, search, filters) {
  console.log("sorting field")
  let { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
    per_page, page, FieldFormsResult.expand, orderByInfo, orderByDirection, filters
  )
  const filter = {};
  const isDefaults = filters.find(r => r.defaults);

  if (isDefaults) {
    const defaults = isDefaults.defaults;
    if(defaults.projectId) filter["Ihwi/Inspection/Rassignment/ProjectId"] = { eq: { type: 'guid', value: defaults.projectId }};
    if(defaults.inspectionNumber) filter["Ihwi/Inspection/InspectionNumber"] = defaults.inspectionNumber;
  };
  const allFilters = mappedFilter.reduce((a, b) => ({...a, ...b}), filter);
  if(isNaN(skip)) skip = 0;
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });
  const data = await ApiRequest(fieldFormsResultEndpoint, params);

  return convertFieldFormsToTableSchema(data);
};


async function getFieldFormResultDetails(fieldTestId) {
  const filter = { "FieldTestId": { eq: { type: 'guid', value: fieldTestId } } };
  const expand = FieldFormResultDetails.expand;
  const params = buildQuery({ filter, expand });
  const req = await ApiRequest(fieldFormsResultEndpoint, params);
  const { data } = FieldFormResultDetails.convertToTableRows(req);
  data.forEach((item, index) => {
    if(item.StationPartA && item.StationPartB) {
      item.Station = `${item.StationPartA} + ${item.StationPartB}`
    } else {
      item.Station = undefined;
    }
  })
  return data[0];
}


const approveWithEngJudgementSchema = (userName, fieldTestId) => {
  const approveSchema = new Schema("Review Inspection");
  approveSchema.addField(new Field({fieldName: "FieldTestId", label: "Field Test ID", type: "string", required: true, disabled: true, defaultValue: fieldTestId}));
  approveSchema.addField(new Field({ fieldName: "Reviewer", label: "User", type: 'string', required: true, defaultValue: userName, disabled: true }));
  approveSchema.addField(new Field({ fieldName: "ReviewDate", type: 'string', label: "Review Date", required: true, disabled: true, defaultValue: new Date().toISOString(), format: 'date-time', nullable: false }));
  approveSchema.addField(new Field({fieldName: "ReviewStatusId", type: "string", label: "Review Status", $ref: "/api/Domain?domainName=LuReviewStatus&includeReserved=false", required: true}));
  approveSchema.addField(new Field({ fieldName: 'Comments', type: 'string', label: 'Comments', required: true, min: 5 }));
  return approveSchema;
};

async function addFieldFormTestReview(data) {
  const endpoint = "/TestFieldFormsResults/Review/Add";
  const req = await postItem(endpoint, '', data);
  return req;
}

async function getFieldFormFile(fieldTestId) {
  const endpoint = "/TestFieldForms/Files";
  const req = await ApiRequest(endpoint, `?fieldTestId=${fieldTestId}`);
  return req.data;
}

export { getFieldFormsResults, getFieldFormResultDetails, approveWithEngJudgementSchema, addFieldFormTestReview, getFieldFormFile };